import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './Router';
import { NotificationProvider } from './context/notification.context';

function App() {
  const [mensaje, setMensaje] = useState('');



  return (
    <NotificationProvider>
      <BrowserRouter>
        <AppRouter/>
      </BrowserRouter>
    </NotificationProvider>
    /*
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <h1 className="text-3xl font-bold underline">{mensaje}</h1>
    </div>*/
  );
}

export default App;
